import {Card, Progress, Space, Table, Typography, Tag, Divider, Row} from "antd";
import React from "react";
import {darkenHexColor, stepHexColor} from "../../utils/colorUtils";

/**
 * Snapshot component is used to display the current symbols within a portfolio
 * @param snapshot {Array[Object]} - Array of objects containing the symbol and weight
 * @param categoryMapping {Object, optional} - Object mapping symbols to categories that can be colorized
 * @returns {JSX.Element}
 * @constructor
 */
const Snapshot = ({snapshot, categoryMapping, colorLookup})=>{
    const baseColor = categoryMapping ? '#fff':"#000";
    console.log(snapshot, categoryMapping, colorLookup)
    const columns = [
        {
            title: 'Symbol',
            dataIndex: 'key',
            key: 'key',
            render: (text, record)=>(
                <Typography.Text style={{color: baseColor}}>
                    {text==='custodial_cash' ? 'CASH': text.toUpperCase()}
                </Typography.Text>
            ),
            width: 100
        },
        { title: 'Weight (%)', dataIndex: 'wgt', key: 'wgt', render: (text, record)=>(
            record.wgt > 0 ? <Progress
                    className={'text-white'}
                    status={'normal'}
                    strokeColor={baseColor}
                    percent={record.wgt*100}
                    format={(pct)=>`${pct.toFixed(0)}%`}
                    percentPosition={{
                        align: 'end',
                        type: 'outer'
                    }}
                    strokeLinecap={'round'}
                    trailColor={'rgba(0, 0, 0, 0.2)'}
                    size={[100, 12]}

                /> : <span>-</span>
            )
        }
    ];



    return (
        <Card
            bordered={false}
        >
            <Row style={{marginBottom: 15}}>
                {Object.keys(categoryMapping).map((key, idx)=><Tag bordered={false} style={{background: categoryMapping[key], padding: '1px 4px', color: '#fff', fontSize: '11px'}}>{key.toUpperCase()}</Tag>)}
            </Row>
            <Table className={'space-rows small styled'}
                   dataSource={snapshot}
                   onRow={(record, rowIndex) => {
                       const color = categoryMapping[colorLookup[record.key]] || '#1A1E23';
                       return {
                           style: {
                               background: `linear-gradient(to right, ${color}, ${stepHexColor(color, 10, -10)})`,
                               zIndex: 100000,
                               opacity: record.wgt > 0 ? 1: 0.1,


                           }
                       }
                   }}
                   columns={columns}
                   pagination={{pageSize: 20, hideOnSinglePage: true, position: 'bottomLeft'}}

            />
        </Card>
    )
}

export default Snapshot